export default "__VITE_ASSET__DNJ6_mtD__"